<div class="loading-shade" *ngIf="!handover || isLoading">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="handover" class="handover-detail">
  <div class="header">
    <div class="element-header left-side">
      <div class="well-name">
        <a class="go-back" (click)="goToBack()">
          <mat-icon class="material-icons-outlined icon-back"
            >arrow_back_ios_new</mat-icon
          >Pozo {{ handover.wellName }}
        </a>
      </div>
      <div class="access-dwf">
        <a target="_blank" [href]="dwfUrl">
          <span>Acceso DWF</span>
        </a>
      </div>
    </div>
    <div class="element-header handover-step">
      <div class="boxItem from-area">
        <label for="">{{ handover.fromAreaName }}</label>
      </div>
      <div class="boxItem conector">
        <span class="ho-type">{{ handover.handoverType }}</span
        ><br /><span class="ho-reason">{{ reasonName }}</span>
      </div>
      <div class="boxItem to-area">
        <label for="">{{ handover.toAreaName }}</label>
      </div>
    </div>
    <div class="element-header handover-save">
      <button
        *ngIf="
          (havePermissionCancel && !readOnlyContent) ||
          (iAmTheSenderUser && hoActive)
        "
        mat-button
        (click)="cancelHandover()"
        class="button-cancel"
      >
        Cancelar Handover
      </button>
      <span matTooltip="{{ saveButtonToolTip }}">
        <button
          *ngIf="havePermissionSend && !readOnlyContent"
          mat-icon-button
          class="button-save"
          aria-label="Enviar Handover"
          (click)="validateAndSendHandover()"
          [disabled]="buttonSendHoDisabled || buttonSendPushed"
        >
          <mat-icon class="material-icons-outlined">send</mat-icon> Enviar
          Handover
        </button>
      </span>
      <span
        *ngIf="readOnlyContent && !displayFooterReceiver && isEmitterSide"
        class="view-mode"
      >
        <button
          matTooltip="En este modo unicamente se permite visualizar información"
          mat-icon-button
          class="button-view-mode"
          aria-label="Estas en modo visualización "
        >
          <mat-icon class="material-icons-outlined">visibility</mat-icon>
          Estas en modo visualización
        </button>
        <span> En gestion por {{ handover.fromAreaName }} </span>
        <span> Usuario Asignado: {{ takenEmittersUsers }} </span>
      </span>
      <span
        *ngIf="readOnlyContent && !displayFooterReceiver && isReceiverSide"
        class="view-mode"
      >
        <button
          matTooltip="En este modo unicamente se permite visualizar información"
          mat-icon-button
          class="button-view-mode"
          aria-label="Estas en modo visualización "
        >
          <mat-icon class="material-icons-outlined">visibility</mat-icon>
          Estas en modo visualización
        </button>
        <span> En gestion por {{ handover.toAreaName }} </span>
        <span> Usuario Asignado: {{ takenReceiversUsers }} </span>
      </span>
      <button
        *ngIf="
          readOnlyContent &&
          !displayFooterReceiver &&
          !isEmitterSide &&
          !isReceiverSide
        "
        matTooltip="En este modo unicamente se permite visualizar información"
        mat-icon-button
        class="button-view-mode"
        aria-label="Estas en modo visualización "
      >
        <mat-icon class="material-icons-outlined">visibility</mat-icon>
        Estas en modo visualización
      </button>
    </div>
  </div>

  <mat-sidenav-container class="sidenav-detail">
    <mat-sidenav
      position="end"
      mode="side"
      disableClose
      fixedTopGap="226"
      opened
    >
      <button
        mat-icon-button
        aria-label="Ver Datos Generales"
        class="well-data"
        [ngClass]="{ open: wellDataIsOpen }"
        title="Ver datos generales"
        (click)="openDatosGenerales()"
      >
        <mat-icon class="material-icons-outlined">info</mat-icon>
      </button>
      <button
        mat-icon-button
        aria-label="Esquema de Pozo"
        [ngClass]="{ open: displaySchematicComponent }"
        title="Ver Esquema de Pozo"
        (click)="toggleSchematicDrawer()"
      >
        <mat-icon svgIcon="well-schematic-icon"></mat-icon>
      </button>
      <button
        mat-icon-button
        aria-label="Comentarios"
        [ngClass]="{ open: displaySectionCommentComponent }"
        title="Comentarios"
        (click)="toggleCommentsDrawer()"
      >
        <mat-icon class="material-icons-outlined">chat_bubble_outline</mat-icon>
        <div class="circle-sections-comments" *ngIf="hasSectionsComments"></div>
      </button>
      <button
        *ngIf="isHo5"
        mat-icon-button
        aria-label="Acceso a DWF/Abandono"
        title="Acceso a DWF/Abandono"
        (click)="linkDwfAbandon()"
      >
        <mat-icon class="material-icons-outlined">folder</mat-icon>
      </button>
      <button
        *ngIf="isHo5"
        [disabled]="!isAcceptedHo"
        mat-icon-button
        class="button-abandon-report"
        [title]="
          !isAcceptedHo
            ? 'El handover debe ser aceptado para poder descargar el informe'
            : 'Descargar informe de abandono'
        "
        (click)="getHoAbandonReport()"
      >
        <mat-icon class="material-icons-outlined">file_download</mat-icon>
      </button>
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-drawer-container
        class="schematic-comments-container"
        [hasBackdrop]="false"
      >
        <mat-drawer
          #drawer
          [mode]="'over'"
          position="end"
          [opened]="drawerIsOpened"
        >
          <div class="close">
            <button
              mat-icon-button
              aria-label="Cerrar"
              title="Cerrar"
              (click)="closeDrawer()"
            >
              <mat-icon class="material-icons-outlined">close</mat-icon>
            </button>
          </div>
          <app-handover-detail-schematic
            *ngIf="displaySchematicComponent"
            [handover]="handover"
          ></app-handover-detail-schematic>
          <app-handover-detail-general
            *ngIf="wellDataIsOpen"
            [handoverId]="handover.handoverId"
            [wellUwi]="handover.wellUwi"
          ></app-handover-detail-general>
          <app-handover-detail-section-comment
            *ngIf="displaySectionCommentComponent"
            [handoverId]="handover.handoverId"
            [handoverRelation]="handoverRelation"
            [readOnlyContent]="readOnlyContentHoecHoac"
            (showRedPointSectionsCommentsEmitter)="
              showRedPointSectionsComments($event)
            "
          >
          </app-handover-detail-section-comment>
        </mat-drawer>
        <mat-drawer-content>
          <mat-tab-group
            class="sections-tabs"
            [ngClass]="{ 'read-only': readOnlyContent || displayFooterEmitter }"
            animationDuration="0ms"
            (click)="onTabGroupClick($event)"
            [selectedIndex]="selectedTabIndex"
          >
            <mat-tab disabled *ngIf="visibleSections[SECCION_ESTADO]">
              <ng-template mat-tab-label>
                <span
                  [ngClass]="{
                    incomplete:
                      isValidated &&
                      (false === sectionsCompletion?.sections?.status ||
                        false === sectionsCompletion?.sections?.notifications)
                  }"
                >
                  Estado y Notificaciones
                </span>
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-status-notifications
                  [handover]="handover"
                  [readOnlyContent]="readOnlyContent"
                  (sectionTouched)="sectionTouched($event)"
                  (hasPendingChanges)="onSectionHasPendingChanges($event)"
                >
                </app-handover-detail-status-notifications>
              </ng-template>
            </mat-tab>
            <mat-tab disabled *ngIf="visibleSections[SECCION_INTEGRIDAD]">
              <ng-template mat-tab-label>
                <span
                  [ngClass]="{
                    incomplete:
                      isValidated &&
                      false == sectionsCompletion?.sections?.wellIntegrity
                  }"
                >
                  Barreras de Pozo
                </span>
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-well-integrity
                  [handover]="handover"
                  [readOnlyContent]="readOnlyContentHoecHoac"
                  [isEngineerUser]="isEngineerUser"
                  (sectionTouched)="sectionTouched($event)"
                  (hasPendingChanges)="onSectionHasPendingChanges($event)"
                >
                </app-handover-detail-well-integrity>
              </ng-template>
            </mat-tab>
            <mat-tab disabled *ngIf="visibleSections[SECCION_ARQUITECTURA]">
              <ng-template mat-tab-label>
                <span>Arquitectura</span>
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-well-architecture
                  [handover]="handover"
                  [readOnlyContent]="readOnlyContentHoecHoac"
                  (hasPendingChanges)="onSectionHasPendingChanges($event)"
                >
                </app-handover-detail-well-architecture>
              </ng-template>
            </mat-tab>
            <mat-tab disabled *ngIf="visibleSections[SECCION_TRAYECTORIA]">
              <ng-template mat-tab-label>
                <span>Trayectoria</span>
              </ng-template>
              <ng-template matTabContent>
                <app-scatter3d-chart
                  [wellUwi]="handover.wellUwi"
                  [readOnlyContent]="readOnlyContent"
                ></app-scatter3d-chart>
              </ng-template>
            </mat-tab>
            <mat-tab disabled *ngIf="visibleSections[SECCION_CEMENTACION]">
              <ng-template mat-tab-label>
                <span
                  [ngClass]="{
                    incomplete:
                      isValidated &&
                      false == sectionsCompletion?.sections?.cementing
                  }"
                >
                  Cementación
                </span>
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-cementing
                  [handover]="handover"
                  [readOnlyContent]="readOnlyContentHoecHoac"
                  (hasPendingChanges)="onSectionHasPendingChanges($event)"
                >
                </app-handover-detail-cementing>
              </ng-template>
            </mat-tab>
            <mat-tab
              disabled
              *ngIf="visibleSections[SECCION_ESPACIOS_ANULARES]"
            >
              <ng-template mat-tab-label>
                <span
                  [ngClass]="{
                    incomplete:
                      isValidated &&
                      false === sectionsCompletion?.sections?.annulusSpaces
                  }"
                >
                  Espacios Anulares
                </span>
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-annulus-spaces
                  [handover]="handover"
                  [readOnlyContent]="readOnlyContentHoec"
                  [isEngineerUser]="isEngineerUser"
                  (sectionTouched)="sectionTouched($event)"
                  (hasPendingChanges)="onSectionHasPendingChanges($event)"
                >
                </app-handover-detail-annulus-spaces>
              </ng-template>
            </mat-tab>
            <mat-tab
              disabled
              *ngIf="visibleSections[SECCION_COLUMNA_PRODUCCION]"
            >
              <ng-template mat-tab-label>
                <span
                  [ngClass]="{
                    incomplete:
                      isValidated &&
                      false === sectionsCompletion?.sections?.productionColumn
                  }"
                >
                  Columna de Producción
                </span>
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-production-column
                  [handoverId]="handover.handoverId"
                  [wellId]="handover.wellId"
                  [handoverStatusId]="handover.handoverStatusId"
                  [readOnlyContent]="readOnlyContent"
                  (sectionTouched)="sectionTouched($event)"
                  (hasPendingChanges)="onSectionHasPendingChanges($event)"
                >
                </app-handover-detail-production-column>
              </ng-template>
            </mat-tab>
            <mat-tab disabled *ngIf="visibleSections[SECCION_PUNZADO]">
              <ng-template mat-tab-label>
                <span>Punzados</span>
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-perforation
                  [handoverId]="handover.handoverId"
                  [wellId]="handover.wellId"
                  [handoverStatusId]="handover.handoverStatusId"
                  [handoverTypeId]="handover.handoverTypeId"
                  [readOnlyContent]="readOnlyContent"
                  [wellUwi]="handover.wellUwi"
                >
                </app-handover-detail-perforation>
              </ng-template>
            </mat-tab>
            <mat-tab disabled *ngIf="visibleSections[SECCION_ENSAYOS]">
              <ng-template mat-tab-label>
                <span>Ensayos</span>
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-tests
                  [handoverId]="handover.handoverId"
                  [handoverStatusId]="handover.handoverStatusId"
                  [wellName]="handover.wellName"
                >
                </app-handover-detail-tests>
              </ng-template>
            </mat-tab>
            <mat-tab disabled *ngIf="visibleSections[SECCION_FRACTURA]">
              <ng-template mat-tab-label>
                <span>Fractura</span>
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-fracture
                  [handoverId]="handover.handoverId"
                  [wellId]="handover.wellId"
                  [handoverStatusId]="handover.handoverStatusId"
                  [readOnlyContent]="readOnlyContent"
                  [wellName]="handover.wellName"
                >
                </app-handover-detail-fracture>
              </ng-template>
            </mat-tab>
            <mat-tab disabled *ngIf="visibleSections[SECCION_PERFILES]">
              <ng-template mat-tab-label>
                <span
                  [ngClass]="{
                    incomplete:
                      isValidated &&
                      false === sectionsCompletion?.sections?.profiles
                  }"
                >
                  Perfiles
                </span>
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-profiles
                  [handover]="handover"
                  [readOnlyContent]="readOnlyContentHoecHoac"
                  (sectionTouched)="sectionTouched($event)"
                  (hasPendingChanges)="onSectionHasPendingChanges($event)"
                >
                </app-handover-detail-profiles>
              </ng-template>
            </mat-tab>
            <mat-tab disabled *ngIf="visibleSections[SECCION_CABEZAL]">
              <ng-template mat-tab-label>
                <span
                  [ngClass]="{
                    incomplete:
                      isValidated &&
                      false == sectionsCompletion?.sections?.wellhead
                  }"
                  >Cabezal</span
                >
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-wellhead
                  [handover]="handover"
                  [wellId]="handover.wellId"
                  [handoverRelation]="handoverRelation"
                  [readOnlyContent]="readOnlyContentHoecHoac"
                  (hasPendingChanges)="onSectionHasPendingChanges($event)"
                >
                </app-handover-detail-wellhead>
              </ng-template>
            </mat-tab>
            <mat-tab disabled *ngIf="visibleSections[SECCION_BOCA_POZO]">
              <ng-template mat-tab-label>
                <span>Instalación de Boca de Pozo</span>
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-tree
                  [handoverId]="handover.handoverId"
                  [wellId]="handover.wellId"
                  [handoverTypeAreaReasonId]="handover.handoverTypeAreaReasonId"
                  [handoverStatusId]="handover.handoverStatusId"
                  [readOnlyContent]="readOnlyContent"
                  (hasPendingChanges)="onSectionHasPendingChanges($event)"
                >
                </app-handover-detail-tree>
              </ng-template>
            </mat-tab>

            <mat-tab disabled *ngIf="visibleSections[SECCION_ABANDONO]">
              <ng-template mat-tab-label>
                <span>Abandono</span>
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-abandon
                  [handoverId]="handover.handoverId"
                  [wellId]="handover.wellId"
                  [handoverStatusId]="handover.handoverStatusId"
                  [readOnlyContent]="readOnlyContent"
                  (hasPendingChanges)="onSectionHasPendingChanges($event)"
                >
                </app-handover-detail-abandon>
              </ng-template>
            </mat-tab>
            <mat-tab
              disabled
              *ngIf="
                visibleSections[SECCION_ENTREGA_LOCACION] &&
                displayDeliveryLocation()
              "
            >
              <ng-template mat-tab-label>
                <span
                  [ngClass]="{
                    incomplete:
                      isValidated &&
                      false == sectionsCompletion?.sections?.deliveryLocation
                  }"
                  >Entrega de Locación</span
                >
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-location
                  [handover]="handover"
                  [handoverRelation]="handoverRelation"
                  [readOnlyContent]="readOnlyContent"
                  (hasPendingChanges)="onSectionHasPendingChanges($event)"
                >
                </app-handover-detail-location>
              </ng-template>
            </mat-tab>
            <mat-tab disabled *ngIf="showExecutiveResume">
              <ng-template mat-tab-label>
                <span>Resumen Ejecutivo</span>
              </ng-template>
              <ng-template matTabContent>
                <app-handover-detail-executive-resume
                  [handover]="handover"
                >
                </app-handover-detail-executive-resume>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
          <div
            class="handover-footer"
            *ngIf="displayFooterReceiver && showReceiverFooter"
          >
            <app-handover-detail-footer-receiver
              (isLoadingEmmitter)="changeStatusLoading($event)"
              [handover]="handover"
              [readOnlyContent]="readOnlyContent"
              (hasFooterPendingChanges)="onFooterHasPendingChanges($event)"
            ></app-handover-detail-footer-receiver>
          </div>
          <div
            class="handover-footer"
            *ngIf="displayFooterReceiver && showReceiversFooter"
          >
            <app-handover-detail-footer-receivers
              (isLoadingEmmitter)="changeStatusLoading($event)"
              [handover]="handover"
              [readOnlyContent]="readOnlyContent"
              (hasFooterPendingChanges)="onFooterHasPendingChanges($event)"
            ></app-handover-detail-footer-receivers>
          </div>
          <div class="handover-footer" *ngIf="displayFooterEmitter && !isDr">
            <app-handover-detail-footer-emitter
              [wellName]="handover.wellName"
              [handover]="handover"
              [readOnlyContent]="readOnlyContent"
              (hasFooterPendingChanges)="onFooterHasPendingChanges($event)"
            ></app-handover-detail-footer-emitter>
          </div>
          <div class="handover-footer" *ngIf="displayFooterEmitter && isDr">
            <app-handover-detail-footer-emitters
              [wellName]="handover.wellName"
              [handover]="handover"
              [readOnlyContent]="readOnlyContent"
              (hasFooterPendingChanges)="onFooterHasPendingChanges($event)"
            ></app-handover-detail-footer-emitters>
          </div>
          <div class="handover-footer" *ngIf="displayFooterView">
            <app-handover-detail-footer-view
              [wellName]="handover.wellName"
              [handover]="handover"
            >
            </app-handover-detail-footer-view>
          </div>
        </mat-drawer-content>
      </mat-drawer-container>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
